import classNames from 'classnames';

import './status-tabs.scss';

export interface StatusTab {
  key: string;
  label: string;
  // Left out while it is still loading, so no tab shows a misleading zero.
  count?: number;
}

interface StatusTabsProps {
  tabs: StatusTab[];
  active: string;
  onChange: (key: string) => void;
  label?: string;
}

/*
 * Quick switches between the slices of a listing people visit most, each with
 * how many rows it holds. The full status filter stays in the filter row; these
 * only save the trip to it.
 */
export default function StatusTabs({
  tabs,
  active,
  onChange,
  label = 'Status',
}: StatusTabsProps) {
  return (
    <div className="status-tabs" role="tablist" aria-label={label}>
      {tabs.map((tab) => {
        const isActive = tab.key === active;

        return (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={classNames('status-tabs__tab', {
              'status-tabs__tab--active': isActive,
            })}
            onClick={() => !isActive && onChange(tab.key)}
          >
            {tab.label}
            {tab.count !== undefined && (
              <span className="status-tabs__count">
                {tab.count.toLocaleString()}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
